import "./FrontPage.css";

import React from "react";
import { useState, useEffect } from "react";

import { NavBar } from "../../navigation/NavBar/NavBar";
import { SectionOne } from "./frontPageSections/SectionOne/SectionOne";
import { SectionTwo } from "./frontPageSections/SectionTwo/SectionTwo";
import { SectionThree } from "./frontPageSections/SectionThree/SectionThree";
import { SectionFour } from "./frontPageSections/SectionFour/SectionFour";
import { SectionFive } from "./frontPageSections/SectionFive/SectionFive";
import { SectionSix } from "./frontPageSections/SectionSix/SectionSix";
import { SectionSeven } from "./frontPageSections/SectionSeven/SectionSeven";
import { Footer } from "../../shared/Footer/Footer";

export const FrontPage = ({
  mobileNavShowFunction,
  handleCartItemsCountChange,
  changeNavBar,
  itemsData,
}) => {
  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "") {
      changeNavBar("isProducts", "white", "transparent", "15rem", "column");
      // changeNavBar("isHome", "white", "transparent", "white");
    }
  }, []);
  return (
    <div className="front-page-container">
      <SectionOne />
      <SectionTwo />
      <SectionThree itemsData={itemsData} />
      <SectionFour />
      <SectionFive />
      {/* <SectionSix /> */}
      {/* <SectionSeven /> */}
    </div>
  );
};
